import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../Layout/Main/header/Header";
import Footer from "../../Layout/Main/footer/FooterTwo";
const Content = [
{
    subTitle: 'Make a checklist of your items',
    Content: 'First, make a checklist of what household items you required. Everyone"s list is different because it all depends on how much time do you have. Some people have two months for packing while some have only two weeks. So, arrange your checklist accordingly.',
    id: 1
},
{
    subTitle: 'Categorize so you can pick less',
    Content: 'A crucial packing tip is to make a list of things you do not need. You can lighten your stress and workload by sell or donate all the stuff you no longer need. Measure the new place where you are going and get rid of all furniture that will not fit in your new location.',
    id: 2
},
{
    subTitle: 'Purchase some quality moving boxes',
    Content: 'If you want to put heavy things in boxes, then buy boxes of good quality, so they do not fall apart in your hands while you are trying to move it into other places. Grocery boxes or reused boxes can be compromised due to moisture.',
    id: 3
},
{
    subTitle: 'First pack essential things',
    Content: 'When you are moving to a new place first pack the things which you needed most, because all the boxes contain the same color, so you do not mix the essential stuff.',
    id: 4
},
{
    subTitle: 'Use the color packing label.',
    Content: 'To stay organized, use the color label and put it on boxes. This moving tip can save your ton of time. You do not have to get panic for finding the important material. ',
    id: 5
},
{
    subTitle: 'Do not overload your moving box',
    Content: 'A lot of people made a massive mistake while moving; they cram all their belongings in a few boxes and overload them. As a result, the box itself unbox in your hand. Use as many boxes as you need to create easy-to-lift loads. Try to keep your most jumbo boxes to not more than fifty pounds.',
    id: 6
},
{
    subTitle: 'Use the right box for the right material',
    Content: 'Put heavy material like books in small boxes and light things in large boxes to make it easier for the mover to organize and pack all boxes in the moving truck. Make sure to put heavier items on the bottom and the lighter one on the top to avoid damaging the fragile items.',
    id: 7
},
{
    subTitle: 'Fill all the spaces in the box',
    Content: 'After putting all the material in the box, if the small spaces left then, fill that spaces with packing paper, clothing or form, peanuts, etc. Use tape at the bottom and top of the box. You can also use tape in places where stress is concentrated.',
    id: 8
},


];
class Tips extends Component{
    render(){
        let title = 'Moving Tips';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Packing' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Packing'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-8 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title text-left">{title}</h2>
                                            <p className="description text-left pt--50">Moving your household materials from one location to another location is such a stress. <a href="/"><b>Moonline</b></a> is there to help you. We will provide a discount to customers who refer us to friends and family. You can also trust <a href="/"><b>Moonline</b></a> by seeing our hundreds of positive moving reviews and satisfied customers.</p>
                                            <p className="description text-left pt--10">When you move to another place, transporting large and bulky items without damaging them or without injuring yourself is always a challenge</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Heavy and large Items may include</h3>
                                        </div>
                                        {Content.map( (val , i) => (
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">{val.subTitle}</h3>
                                                    <p>{val.Content}</p>
                                                </div>
                                            </div>
                                        </div>
                                        ))}
                                            <div className="row mt--30 text-left">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div className="about-us-list">
                                                        <h3 className="title">Electronics Packing & Installation</h3>
                                                        <p>If you are moving your office then there are computers, photocopiers and other electronics that need to be handled with extra care. We will pack these items with special care and move them to your desired location. Then we also help you to reinstall your systems to make your move effortless and hassle-free.</p>
                                                        <p>If you are planning a local or long-distance move then you can always trust <a href="/">Moonline</a> for packing and unpacking of your valuable items. We are a licensed and insured company and we provide you complete security and safety of your belongings. We offer our services at most affordable and competitive prices. Our aim is to be your go-to trusted moving partner for all kinds of moving services. To get a free estimate for our packing services you can contact us through our website or <a href="/contact">call us,</a> and one of our moving specialists will assist you in the best possible ways.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Tips;